<div class="row">
  <div class="col-12">
    Do you have a question or comment for us? Please use the social media links
    on the home page, or send an email to
    <a href="mailto:info@littlejarsofhorror.com">info@littlejarsofhorror.com</a
    >.
  </div>
</div>
